import type { ApiDataResponse, ApiSitemapItem } from '@app/packages/internalApi/types'
import { createInternalApiAction } from '@app/packages/internalApi/utils'

export const getSitemap = () =>
  createInternalApiAction('getSitemap', dispatch =>
    dispatch<ApiDataResponse<ApiSitemapItem[]>>({
      method: 'GET',
      endpoint: '/internal/api/v1/sitemap',
    })
  )
